import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import NavDrawer from "../../components/NavDrawer/NavDrawer";
import axios from "../../api/axiosInstance";
import { CashFundCard } from "../../components/Cashfund/CashFundCard";

const Funds_Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const [cashFunds, setCashFunds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const fetchCashFunds = async () => {
    try {
      setLoading(true);
      setErr("");
      const res = await axios.get("/v1/cashfund/my");
      setCashFunds(res.data.data || []);
    } catch (e) {
      setErr(e.response?.data?.message || "Failed to load funds.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCashFunds();
  }, []);

  return (
    <div style={{ minHeight: "100vh", position: "relative", background: "#FFFDFB" }}>
      <Navbar />
      <div style={{ display: "flex", flexDirection: "row" }}>
        {/* Drawer */}
        <div style={{ flexShrink: 0, width: 120, background: "#fff" }}>
          <NavDrawer highlight="FUNDS" />
        </div>
        {/* Main Content */}
        <div style={{
          flex: 1,
          padding: "48px 36px 36px 36px",
          maxWidth: 1200,
          margin: "0 auto",
        }}>
          <div style={{
            paddingTop: 32,
            textAlign: "center"
          }}>
            
          
          </div>
          {/* Cash Funds List */}
          <div style={{ margin: "46px auto", maxWidth: "1100px" }}>
            <h2 style={{
              fontFamily: "Nunito, sans-serif",
              fontWeight: 700,
              fontSize: "2rem",
              letterSpacing: ".12em",
              marginBottom: 20,
              marginTop: 0
            }}>
              My Cash Funds
            </h2>
            {loading && <div>Loading...</div>}
            {err && <div style={{ color: "red" }}>{err}</div>}
            {!loading && !err && cashFunds.length === 0 && (
              <div>No cash funds found.</div>
            )}
            <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "28px",
              justifyContent: "flex-start",
            }}>
              {cashFunds.map(fund => (
                <CashFundCard key={fund.cash_fund_id} fund={fund} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Funds_Dashboard;
